"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lifecycleStatuses = exports._getChainSpecificConstants = exports._extractChainID = exports.customErrors = exports.holeskyLSDUrls = exports.mainnetLSDUrls = exports.goerliLSDUrls = exports.holeskyFactoryAddresses = exports.mainnetFactoryAddresses = exports.goerliFactoryAddresses = exports.CHAIN_ID = exports.ONE_ETHER = exports.ONE_GWEI = exports.ZERO = void 0;
const ethers_1 = require("ethers");
exports.ZERO = ethers_1.ethers.BigNumber.from('0');
exports.ONE_GWEI = ethers_1.utils.parseUnits('1', 'gwei');
exports.ONE_ETHER = ethers_1.utils.parseUnits('1', 'ether');
var CHAIN_ID;
(function (CHAIN_ID) {
    CHAIN_ID[CHAIN_ID["MAINNET"] = 1] = "MAINNET";
    CHAIN_ID[CHAIN_ID["GOERLI"] = 5] = "GOERLI";
    CHAIN_ID[CHAIN_ID["HOLESKY"] = 17000] = "HOLESKY";
})(CHAIN_ID = exports.CHAIN_ID || (exports.CHAIN_ID = {}));
;
exports.goerliFactoryAddresses = {
    LSDN_FACTORY: "0xe9482a9b8f3ea7400d4b07c798287d94b036be5c",
    GIANT_SAVETH_POOL: "0x7e30089243E412291e9e5b981F9018Ca40e84eED",
    GIANT_FEES_AND_MEV_POOL: "0xf3D21065A25bebd2357288978fe0e3083736E2bC",
    SMART_WALLET_NAMING_REGISTRY: "0x78F82286eBd81879672285684CAA5CfC93c48E08",
    DETH: "0x506C2B850D519065a4005b04b9ceed946A64CB6F",
    ZEC: ""
};
exports.mainnetFactoryAddresses = {
    LSDN_FACTORY: "0x6EDd4DDa4F879541A67366bca844b2D78cC3850A",
    GIANT_SAVETH_POOL: "0xF5D92B01c478273bD13aA8efb130D98e131ecBB9",
    GIANT_FEES_AND_MEV_POOL: "0x04e5c93f4b96D2fdB2cDE4c9826C373e5656796E",
    SMART_WALLET_NAMING_REGISTRY: "0xfC40C203d6b0976526Dd169F2c21AF53B8f2a372",
    DETH: "0x3d1E5Cf16077F349e999d6b21A4f646e83Cd90c5",
    ZEC: ""
};
exports.holeskyFactoryAddresses = {
    LSDN_FACTORY: "0xa38042b7109bb777E6dE177C065e98465039b81c",
    GIANT_SAVETH_POOL: "0x01eFEC3E88604a87bE4dfAa6E9Dac7699b2829d1",
    GIANT_FEES_AND_MEV_POOL: "0xdC1837DA5D8E5A4C332B871820C43f594Aa0D2a5",
    SMART_WALLET_NAMING_REGISTRY: "0xa987Ce47C76584fC9cDc1E5192A393360693a487",
    DETH: "0x4Bfc9573a96B883c477EeD548b5fCC30C5Dfeb82",
    ZEC: ""
};
exports.goerliLSDUrls = {
    SUBGRAPH_ENDPOINT: "https://goerli-lsd-subgraph.joinstakehouse.com",
    STAKEHOUSE_SUBGRAPH_ENDPOINT: "https://goerli-stakehouse-subgraph.joinstakehouse.com"
};
exports.mainnetLSDUrls = {
    SUBGRAPH_ENDPOINT: "https://lsd-subgraph.joinstakehouse.com",
    STAKEHOUSE_SUBGRAPH_ENDPOINT: "https://stakehouse-subgraph.joinstakehouse.com"
};
exports.holeskyLSDUrls = {
    SUBGRAPH_ENDPOINT: "https://holesky-lsd-subgraph.joinstakehouse.com",
    STAKEHOUSE_SUBGRAPH_ENDPOINT: "https://holesky-stakehouse-subgraph.joinstakehouse.com"
};
exports.customErrors = {
    UNEQUAL_ARRAY_LENGTH: "Error: Unequal array size. Must provide arrays of equal length",
    NULL_OR_UNDEFINED_VALUE: "Error: Null or undefined value provided"
};
const _extractChainID = (signerOrProvider) => __awaiter(void 0, void 0, void 0, function* () {
    if (!signerOrProvider) {
        throw "Invalid signer or provider instance";
    }
    if (ethers_1.Signer.isSigner(signerOrProvider)) {
        return signerOrProvider.getChainId();
    }
    const network = yield signerOrProvider.getNetwork();
    if (!network) {
        throw "Invalid signer or provider instance";
    }
    return network.chainId;
});
exports._extractChainID = _extractChainID;
const _getChainSpecificConstants = (chainID) => {
    if (chainID === CHAIN_ID.GOERLI) {
        return {
            factoryAddresses: exports.goerliFactoryAddresses,
            customErrors: exports.customErrors,
            lsdUrls: exports.goerliLSDUrls
        };
    }
    else if (chainID === CHAIN_ID.HOLESKY) {
        return {
            factoryAddresses: exports.holeskyFactoryAddresses,
            customErrors: exports.customErrors,
            lsdUrls: exports.holeskyLSDUrls
        };
    }
    else {
        return {
            factoryAddresses: exports.mainnetFactoryAddresses,
            customErrors: exports.customErrors,
            lsdUrls: exports.mainnetLSDUrls
        };
    }
};
exports._getChainSpecificConstants = _getChainSpecificConstants;
var lifecycleStatuses;
(function (lifecycleStatuses) {
    lifecycleStatuses[lifecycleStatuses["UNBEGUN"] = 0] = "UNBEGUN";
    lifecycleStatuses[lifecycleStatuses["INITIALS_REGISTERED"] = 1] = "INITIALS_REGISTERED";
    lifecycleStatuses[lifecycleStatuses["DEPOSIT_COMPLETED"] = 2] = "DEPOSIT_COMPLETED";
    lifecycleStatuses[lifecycleStatuses["TOKENS_MINTED"] = 3] = "TOKENS_MINTED";
    lifecycleStatuses[lifecycleStatuses["EXITED"] = 4] = "EXITED";
})(lifecycleStatuses = exports.lifecycleStatuses || (exports.lifecycleStatuses = {}));
;
